// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__2OGqy","container":"styles_container__36fWI","redirect":"styles_redirect__1b9-I"};